export class API {
  private _endpoint: string;

  constructor(endpoint: string) {
    this._endpoint = endpoint;
  }

  public getEndpoint() {
    return this._endpoint;
  }
}
